/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

/*
 * action types
 */
export const GET_USER_CART_ITEM_REQUEST = "GET_USER_CART_ITEM_REQUEST";
export const GET_USER_CART_ITEM_SUCCESS = "GET_USER_CART_ITEM_SUCCESS";
export const GET_USER_CART_ITEM_FAILURE = "GET_USER_CART_ITEM_FAILURE";
export const DELETE_USER_CART_ITEM_REQUEST = "DELETE_USER_CART_ITEM_REQUEST";
export const DELETE_USER_CART_ITEM_SUCCESS = "DELETE_USER_CART_ITEM_SUCCESS";
export const DELETE_USER_CART_ITEM_FAILURE = "DELETE_USER_CART_ITEM_FAILURE";
export const APPLY_USER_CART_WALLET_REQUEST = "APPLY_USER_CART_WALLET_REQUEST";
export const APPLY_USER_CART_WALLET_SUCCESS = "APPLY_USER_CART_WALLET_SUCCESS";
export const APPLY_USER_CART_WALLET_FAILURE = "APPLY_USER_CART_WALLET_FAILURE";
export const APPLY_USER_CART_POINT_REQUEST = "APPLY_USER_CART_POINT_REQUEST";
export const APPLY_USER_CART_POINT_SUCCESS = "APPLY_USER_CART_POINT_SUCCESS";
export const APPLY_USER_CART_POINT_FAILURE = "APPLY_USER_CART_POINT_FAILURE";
export const ADD_USER_CART_FOOD_REQUEST = "ADD_USER_CART_FOOD_REQUEST";
export const ADD_USER_CART_FOOD_SUCCESS = "ADD_USER_CART_FOOD_SUCCESS";
export const ADD_USER_CART_FOOD_FAILURE = "ADD_USER_CART_FOOD_FAILURE";
export const EDIT_USER_CART_FOOD_REQUEST = "EDIT_USER_CART_FOOD_REQUEST";
export const EDIT_USER_CART_FOOD_SUCCESS = "EDIT_USER_CART_FOOD_SUCCESS";
export const EDIT_USER_CART_FOOD_FAILURE = "EDIT_USER_CART_FOOD_FAILURE";
export const SET_DELIVERY_STATUS = "SET_DELIVERY_STATUS";
export const UPDATE_USER_CART_FOOD_DELIVERY_REQUEST =
  "UPDATE_USER_CART_FOOD_DELIVERY_REQUEST";
export const UPDATE_USER_CART_FOOD_DELIVERY_SUCCESS =
  "UPDATE_USER_CART_FOOD_DELIVERY_SUCCESS";
export const UPDATE_USER_CART_FOOD_DELIVERY_FAILURE =
  "UPDATE_USER_CART_FOOD_DELIVERY_FAILURE";
export const CHECKOUT_USER_CART_REQUEST = "CHECKOUT_USER_CART_REQUEST";
export const CHECKOUT_USER_CART_SUCCESS = "CHECKOUT_USER_CART_SUCCESS";
export const CHECKOUT_USER_CART_FAILURE = "CHECKOUT_USER_CART_FAILURE";
export const GET_USER_ORDER_DETAIL_REQUEST = "GET_USER_ORDER_DETAIL_REQUEST";
export const GET_USER_ORDER_DETAIL_SUCCESS = "GET_USER_ORDER_DETAIL_SUCCESS";
export const GET_USER_ORDER_DETAIL_FAILURE = "GET_USER_ORDER_DETAIL_FAILURE";
export const RESET_CART_STATE = "RESET_CART_STATE";
export const UPDATE_USER_ORDER_TABLE_REQUEST =
  "UPDATE_USER_ORDER_TABLE_REQUEST";
export const UPDATE_USER_ORDER_TABLE_SUCCESS =
  "UPDATE_USER_ORDER_TABLE_SUCCESS";
export const UPDATE_USER_ORDER_TABLE_FAILURE =
  "UPDATE_USER_ORDER_TABLE_FAILURE";
export const GET_USER_ORDER_LIST_REQUEST = "GET_USER_ORDER_LIST_REQUEST";
export const GET_USER_ORDER_LIST_SUCCESS = "GET_USER_ORDER_LIST_SUCCESS";
export const GET_USER_ORDER_LIST_FAILURE = "GET_USER_ORDER_LIST_FAILURE";
export const CANCEL_USER_ORDER_REQUEST = "CANCEL_USER_ORDER_REQUEST";
export const CANCEL_USER_ORDER_SUCCESS = "CANCEL_USER_ORDER_SUCCESS";
export const CANCEL_USER_ORDER_FAILURE = "CANCEL_USER_ORDER_FAILURE";
export const UPDATE_USER_ORDER_PAYMENT_REQUEST =
  "UPDATE_USER_ORDER_PAYMENT_REQUEST";
export const UPDATE_USER_ORDER_PAYMENT_SUCCESS =
  "UPDATE_USER_ORDER_PAYMENT_SUCCESS";
export const UPDATE_USER_ORDER_PAYMENT_FAILURE =
  "UPDATE_USER_ORDER_PAYMENT_FAILURE";
export const SET_ORDER_INDICATOR = "SET_ORDER_INDICATOR";
export const CLEAR_ORDER_INDICATOR = "CLEAR_ORDER_INDICATOR";
export const GET_USER_QUEUE_LIST_REQUEST = "GET_USER_QUEUE_LIST_REQUEST";
export const GET_USER_QUEUE_LIST_SUCCESS = "GET_USER_QUEUE_LIST_SUCCESS";
export const GET_USER_QUEUE_LIST_FAILURE = "GET_USER_QUEUE_LIST_FAILURE";
export const GET_USER_QUEUE_READY_ITEM_REQUEST =
  "GET_USER_QUEUE_READY_ITEM_REQUEST";
export const GET_USER_QUEUE_READY_ITEM_SUCCESS =
  "GET_USER_QUEUE_READY_ITEM_SUCCESS";
export const GET_USER_QUEUE_READY_ITEM_FAILURE =
  "GET_USER_QUEUE_READY_ITEM_FAILURE";
export const GET_USER_QUEUE_COMPLETE_ITEM_REQUEST =
  "GET_USER_QUEUE_COMPLETE_ITEM_REQUEST";
export const GET_USER_QUEUE_COMPLETE_ITEM_SUCCESS =
  "GET_USER_QUEUE_COMPLETE_ITEM_SUCCESS";
export const GET_USER_QUEUE_COMPLETE_ITEM_FAILURE =
  "GET_USER_QUEUE_COMPLETE_ITEM_FAILURE";
export const POST_USER_ORDER_PAYMENT_REQUEST =
  "POST_USER_ORDER_PAYMENT_REQUEST";
export const POST_USER_ORDER_PAYMENT_SUCCESS =
  "POST_USER_ORDER_PAYMENT_SUCCESS";
export const POST_USER_ORDER_PAYMENT_FAILURE =
  "POST_USER_ORDER_PAYMENT_FAILURE";
export const UPDATE_ORDER_SUMMARY_TABLE_REQUEST =
  "UPDATE_ORDER_SUMMARY_TABLE_REQUEST";
export const UPDATE_ORDER_SUMMARY_TABLE_SUCCESS =
  "UPDATE_ORDER_SUMMARY_TABLE_SUCCESS";
export const UPDATE_ORDER_SUMMARY_TABLE_FAILURE =
  "UPDATE_ORDER_SUMMARY_TABLE_FAILURE";
export const UPDATE_CHANGE_TABLE_MODAL_REQUEST =
  "UPDATE_CHANGE_TABLE_MODAL_REQUEST";
export const SET_BALANCE_ERROR = "SET_BALANCE_ERROR";

/*
 * action creators
 */
export const getUserCartItemRequest = () => ({
  type: GET_USER_CART_ITEM_REQUEST
});

export const getUserCartItemSuccess = data => ({
  type: GET_USER_CART_ITEM_SUCCESS,
  data
});

export const getUserCartItemFailure = () => ({
  type: GET_USER_CART_ITEM_FAILURE
});

export const deleteUserCartItemRequest = cartID => ({
  type: DELETE_USER_CART_ITEM_REQUEST,
  cartID
});

export const deleteUserCartItemSuccess = data => ({
  type: DELETE_USER_CART_ITEM_SUCCESS,
  data
});

export const deleteUserCartItemFailure = () => ({
  type: DELETE_USER_CART_ITEM_FAILURE
});

export const applyUserCartWalletRequest = walletData => ({
  type: APPLY_USER_CART_WALLET_REQUEST,
  walletData
});

export const applyUserCartWalletSuccess = data => ({
  type: APPLY_USER_CART_WALLET_SUCCESS,
  data
});

export const applyUserCartWalletFailure = () => ({
  type: APPLY_USER_CART_WALLET_FAILURE
});

export const applyUserCartPointRequest = pointData => ({
  type: APPLY_USER_CART_POINT_REQUEST,
  pointData
});

export const applyUserCartPointSuccess = data => ({
  type: APPLY_USER_CART_POINT_SUCCESS,
  data
});

export const applyUserCartPointFailure = () => ({
  type: APPLY_USER_CART_POINT_FAILURE
});

export const addUserCartFoodRequest = (foodID, foodData) => ({
  type: ADD_USER_CART_FOOD_REQUEST,
  foodID,
  foodData
});

export const addUserCartFoodSuccess = data => ({
  type: ADD_USER_CART_FOOD_SUCCESS,
  data
});

export const addUserCartFoodFailure = () => ({
  type: ADD_USER_CART_FOOD_FAILURE
});

export const editUserCartFoodRequest = (cartID, foodData) => ({
  type: EDIT_USER_CART_FOOD_REQUEST,
  cartID,
  foodData
});

export const editUserCartFoodSuccess = data => ({
  type: EDIT_USER_CART_FOOD_SUCCESS,
  data
});

export const editUserCartFoodFailure = () => ({
  type: EDIT_USER_CART_FOOD_FAILURE
});

export const setDeliveryStatus = (cartID, status) => ({
  type: SET_DELIVERY_STATUS,
  cartID,
  status
});

export const updateUserCartFoodDeliveryRequest = (cartID, deliveryStatus) => ({
  type: UPDATE_USER_CART_FOOD_DELIVERY_REQUEST,
  cartID,
  deliveryStatus
});

export const updateUserCartFoodDeliverySuccess = data => ({
  type: UPDATE_USER_CART_FOOD_DELIVERY_SUCCESS,
  data
});

export const updateUserCartFoodDeliveryFailure = () => ({
  type: UPDATE_USER_CART_FOOD_DELIVERY_FAILURE
});

export const checkoutUserCartRequest = checkoutData => ({
  type: CHECKOUT_USER_CART_REQUEST,
  checkoutData
});

export const checkoutUserCartSuccess = data => ({
  type: CHECKOUT_USER_CART_SUCCESS,
  data
});

export const checkoutUserCartFailure = () => ({
  type: CHECKOUT_USER_CART_FAILURE
});

export const getUserOrderDetailRequest = orderID => ({
  type: GET_USER_ORDER_DETAIL_REQUEST,
  orderID
});

export const getUserOrderDetailSuccess = data => ({
  type: GET_USER_ORDER_DETAIL_SUCCESS,
  data
});

export const getUserOrderDetailFailure = () => ({
  type: GET_USER_ORDER_DETAIL_FAILURE
});

export const resetCartState = () => ({
  type: RESET_CART_STATE
});

export const updateUserOrderTableRequest = tableData => ({
  type: UPDATE_USER_ORDER_TABLE_REQUEST,
  tableData
});

export const updateUserOrderTableSuccess = data => ({
  type: UPDATE_USER_ORDER_TABLE_SUCCESS,
  data
});

export const updateUserOrderTableFailure = () => ({
  type: UPDATE_USER_ORDER_TABLE_FAILURE
});

export const getUserOrderListRequest = (pageNumber, hideLoading) => ({
  type: GET_USER_ORDER_LIST_REQUEST,
  pageNumber,
  hideLoading
});

export const getUserOrderListSuccess = (data, pagination) => ({
  type: GET_USER_ORDER_LIST_SUCCESS,
  data,
  pagination
});

export const getUserOrderListFailure = () => ({
  type: GET_USER_ORDER_LIST_FAILURE
});

export const cancelUserOrderRequest = orderID => ({
  type: CANCEL_USER_ORDER_REQUEST,
  orderID
});

export const cancelUserOrderSuccess = () => ({
  type: CANCEL_USER_ORDER_SUCCESS
});

export const cancelUserOrderFailure = () => ({
  type: CANCEL_USER_ORDER_FAILURE
});

export const updateUserOrderPaymentRequest = (paymentID, data) => ({
  type: UPDATE_USER_ORDER_PAYMENT_REQUEST,
  paymentID,
  data
});

export const updateUserOrderPaymentSuccess = data => ({
  type: UPDATE_USER_ORDER_PAYMENT_SUCCESS,
  data
});

export const updateUserOrderPaymentFailure = () => ({
  type: UPDATE_USER_ORDER_PAYMENT_FAILURE
});

export const setOrderIndicator = () => ({
  type: SET_ORDER_INDICATOR
});

export const clearOrderIndicator = () => ({
  type: CLEAR_ORDER_INDICATOR
});

export const getUserQueueListRequest = loading => ({
  type: GET_USER_QUEUE_LIST_REQUEST,
  loading
});

export const getUserQueueListSuccess = data => ({
  type: GET_USER_QUEUE_LIST_SUCCESS,
  data
});

export const getUserQueueListFailure = () => ({
  type: GET_USER_QUEUE_LIST_FAILURE
});

export const getUserQueueReadyItemRequest = loading => ({
  type: GET_USER_QUEUE_READY_ITEM_REQUEST,
  loading
});

export const getUserQueueReadyItemSuccess = data => ({
  type: GET_USER_QUEUE_READY_ITEM_SUCCESS,
  data
});

export const getUserQueueReadyItemFailure = () => ({
  type: GET_USER_QUEUE_READY_ITEM_FAILURE
});

export const getUserQueueCompleteItemRequest = loading => ({
  type: GET_USER_QUEUE_COMPLETE_ITEM_REQUEST,
  loading
});

export const getUserQueueCompleteItemSuccess = data => ({
  type: GET_USER_QUEUE_COMPLETE_ITEM_SUCCESS,
  data
});

export const getUserQueueCompleteItemFailure = () => ({
  type: GET_USER_QUEUE_COMPLETE_ITEM_FAILURE
});

export const postUserOrderPaymentRequest = (orderID, data) => ({
  type: POST_USER_ORDER_PAYMENT_REQUEST,
  data,
  orderID
});

export const postUserOrderPaymentSuccess = (item, success) => ({
  type: POST_USER_ORDER_PAYMENT_SUCCESS,
  success,
  item
});

export const postUserOrderPaymentFailure = () => ({
  type: POST_USER_ORDER_PAYMENT_FAILURE
});

export const updateOrderSummaryTableRequest = (orderID, tableData) => ({
  type: UPDATE_ORDER_SUMMARY_TABLE_REQUEST,
  orderID,
  tableData
});

export const updateOrderSummaryTableSuccess = data => ({
  type: UPDATE_ORDER_SUMMARY_TABLE_SUCCESS,
  data
});

export const updateOrderSummaryTableFailure = () => ({
  type: UPDATE_ORDER_SUMMARY_TABLE_FAILURE
});

export const updateChangeTableModalRequest = status => ({
  type: UPDATE_CHANGE_TABLE_MODAL_REQUEST,
  status
});

export const setBalanceError = status => ({
  type: SET_BALANCE_ERROR,
  status
});



// WEBPACK FOOTER //
// ./src/actions/user.js